import { Button, Modal } from '@dev-spendesk/grapes';

import singleUseCardsEducationalModalImage from 'modules/cards/components/assets/single-use-cards-educational-modal.png';
import { useTranslation } from 'src/core/common/hooks/useTranslation';

type Props = {
  isOpen: boolean;
  onClose: () => void;
};

export const SingleUseCardsEducationalModal = ({ isOpen, onClose }: Props) => {
  const { t } = useTranslation('global');

  return (
    <Modal
      illustration={
        <img
          src={singleUseCardsEducationalModalImage}
          alt=""
          className="h-[373px] w-[600px] object-contain"
        />
      }
      illustrationHeight="373px"
      title={t('singleUseCards.educationalModal.title')}
      subtitle={t('singleUseCards.educationalModal.description')}
      isOpen={isOpen}
      onClose={onClose}
      actions={[
        <Button
          key="got-it"
          onClick={onClose}
          text={t('misc.gotIt')}
          variant="primaryBrand"
        />,
      ]}
    />
  );
};
